import React from 'react';
import {SplitButton} from 'primereact/splitbutton';
const newComponent=(props)=>{     
    
    return (
        <SplitButton  style={{width:"151px"}} className={props.className}  icon={props.icon}  label={props.label} onClick={()=>props.onAdd(props.value)}  model={[{...props.items[0],value:props.value}]}></SplitButton>

    )
} 
export default newComponent